module.exports = __webpack_public_path__ + "img/banner1.5dc2d3ed.jpg";